module.exports = __webpack_public_path__ + "c84f7a938a1b839e2c03e73c30e81161.svg";